import { FC, createContext, PropsWithChildren } from 'react';
import { noop } from 'lodash';
import { useSyncedLocalStorage } from '@/data/Content/SyncedLocalStorage';

export type DpvaleSelected = {
	id?: string;
	folio?: string;
	distributorId?: string;
};

export type DpvaleSelectedContextType = {
	dpvaleSelected: DpvaleSelected;
	setDpvaleSelected: (dpvaleSelected: DpvaleSelected) => void;
};

export const DPVALE_SELECTED_KEY = 'dpvale-selected';
export const DPVALE_SELECTED_DEFAULT_VALUE: DpvaleSelected = {};

export const DpvaleSelectedContext = createContext<DpvaleSelectedContextType>({
	dpvaleSelected: DPVALE_SELECTED_DEFAULT_VALUE,
	setDpvaleSelected: noop,
});

export const DpvaleSelectedProvider: FC<PropsWithChildren> = ({ children }) => {
	const [dpvaleSelected, setDpvaleSelected] = useSyncedLocalStorage(
		DPVALE_SELECTED_KEY,
		DPVALE_SELECTED_DEFAULT_VALUE
	);

	return (
		<DpvaleSelectedContext.Provider value={{ dpvaleSelected, setDpvaleSelected }}>
			{children}
		</DpvaleSelectedContext.Provider>
	);
};
